import { useState } from "react";
import { HeartPulse, History, Siren, ArrowRight } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { Btn } from "@/components/Btn";
import { Logo } from "@/components/Brand";
import { usePrefs, useSavePrefs } from "@/lib/store";

const STEPS = [
  { icon: HeartPulse, title: "Check In", text: "Slide to how distressed you feel, then follow a few gentle questions. Triggerific helps you name what happened, what you needed, and what helped." },
  { icon: Siren, title: "Get Help Now", text: "When distress is high, a calm voice and soothing tones guide your breathing until your body settles. You can choose 432Hz, 528Hz or a singing bowl." },
  { icon: History, title: "History", text: "Every entry is kept here, finished or not. Insights show your patterns over time, and you can send a report to your psychologist in one tap." },
];

export function WelcomeTour() {
  const { data: prefs, isFetched } = usePrefs();
  const save = useSavePrefs();
  const [i, setI] = useState(0);
  const open = isFetched && prefs && !prefs.tourDone;
  const done = () => { save.mutate({ tourDone: true }); setI(0); };
  const { icon: Icon, title, text } = STEPS[i];
  return (
    <Dialog open={!!open} onOpenChange={(o) => !o && done()}>
      <DialogContent className="rounded-3xl bg-t-surface border-t-border max-w-md" data-testid="welcome-tour">
        <div className="flex items-center gap-2 text-t-brand font-bold"><Logo size={22} /> Welcome to Triggerific-Pilot</div>
        <div key={i} className="tf-rise mt-4">
          <span className="w-14 h-14 rounded-2xl bg-t-brand2 text-t-brand grid place-items-center"><Icon size={26} /></span>
          <DialogTitle className="mt-4 text-2xl font-bold text-t-on" data-testid="welcome-tour-title">{title}</DialogTitle>
          <DialogDescription className="mt-2 text-t-on2 leading-relaxed">{text}</DialogDescription>
        </div>
        <div className="mt-4 flex items-center justify-between">
          <div className="flex gap-1.5">{STEPS.map((_, n) => <span key={n} className={`h-2 rounded-full transition-[width,background-color] duration-300 ${n === i ? "w-6 bg-t-brand" : "w-2 bg-t-surface3"}`} />)}</div>
          <div className="flex gap-2">
            <Btn size="md" variant="ghost" label="Skip" onClick={done} testId="welcome-tour-skip" />
            {i < STEPS.length - 1
              ? <Btn size="md" label="Next" icon={<ArrowRight size={16} />} onClick={() => setI(i + 1)} testId="welcome-tour-next" />
              : <Btn size="md" label="Let's begin" onClick={done} testId="welcome-tour-done" />}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
